export default "__VITE_ASSET__BGHmCaKA__"